/**
 * Reads a tile from the image server and stuffs it into a blob. Can handle cross origin requests.
 */
export class ViewportScanner {
  /**
     * The constructor!
     * @param readers (object) List of reader instances that will read the viewport and render it onto a canvas. The
     * order the readers are listed is the order they will render; higher-index readers render on top of lower-index ones.
     * (hint: the annotations reader should be passed in second, since it renders on top of the tiles!)
     */
  constructor (readers) {
    this._readers = readers;
    Object.freeze(this);
  }

  async capture (viewport, rectangle, zoom) {
    // Run the capturers in parallel.
    // TODO: If one of these throws an exception it appears to be considered "unhandled". For instance, try taking a full screen snapshot before annotations are loaded.
    await Promise.all(
      this._readers.map(reader => reader.capture(viewport, rectangle, zoom))
    );

    // Create a canvas to render the results onto
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.height = rectangle.h;
    canvas.width = rectangle.w;

    this._readers.forEach(reader => reader.render(ctx));

    // Extract the result.
    return new Promise((resolve, reject) => {
      let blob;
      let uri;
      if (canvas.toBlob) {
        canvas.toBlob((blob) => {
          uri = URL.createObjectURL(blob);
          resolve({blob, uri});
        });
      } else if (canvas.msToBlob) {
        blob = canvas.msToBlob();
        resolve({blob, uri});
      } else {
        uri = canvas.toDataURL('image/png');
        resolve({blob, uri});
      }
    });
  }

  cleanup () {
    this._readers.forEach(reader => reader.cleanup());
  }
}
